import React from "react";
import { Button } from "../../../../../design/button";
import { Field, Label } from "../../../../../design/fieldset";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Input } from "../../../../../design/input";
import { Select } from "../../../../../design/select";
import { usaStates } from "typed-usa-states";
import { Professional } from "../../../../../models/Professional";
import SelectStatesField from "../../../../../components/Fields/SelectStatesField";

const OnboardingLocationAndLicensingStep: React.FC<{
  formData: Partial<Professional>;
  setFormData: React.Dispatch<React.SetStateAction<Partial<Professional>>>;
  onBack: () => void;
  onStepComplete: () => void;
}> = ({ formData, setFormData, onBack, onStepComplete }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onStepComplete();
  };

  return (
    <OnboardingContainer title="Location and Licensing">
      <>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-4">
            <Field>
              <Label>City</Label>
              <Input
                placeholder="City"
                value={formData.city || ""}
                onChange={(e) =>
                  setFormData({ ...formData, city: e.target.value })
                }
                required
              />
            </Field>

            <Field>
              <Label>State</Label>
              <Select
                value={formData.state || ""}
                onChange={(e) =>
                  setFormData({ ...formData, state: e.target.value })
                }
                required
              >
                <option value="" disabled>
                  Select a state
                </option>
                {usaStates.map((s) => (
                  <option key={s.abbreviation} value={s.abbreviation}>
                    {s.name}
                  </option>
                ))}
              </Select>
            </Field>
          </div>

          <SelectStatesField
            title="Licensed States (*if applicable)"
            values={formData.licensedStates || []}
            onChange={(values) =>
              setFormData({ ...formData, licensedStates: values })
            }
          />

          <Field>
            <Label>Do you offer virtual services?</Label>
            <Select
              value={formData.offersVirtualRoles ? "yes" : "no"}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  offersVirtualRoles: e.target.value === "yes",
                })
              }
            >
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </Select>
          </Field>

          <div className="flex justify-between gap-4">
            <Button type="button" onClick={onBack}>
              Back
            </Button>
            <Button type="submit">Continue</Button>
          </div>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingLocationAndLicensingStep;
